import { DivIcon } from 'leaflet'

import './MapMarker.scss'

export default function MapMarker (color: string) {
  
  return new DivIcon({
    className: 'custom-div-icon',
    iconAnchor: [ 0, 24 ],
    popupAnchor: [ 0, -36 ],
    html: `<div class='marker-pin' style="background-color:${color}"><i class='material-icons'/></div>`
  })
}